<template>
  <b-card>
    <!-- Card body -->
    <b-row align-v="center">
      <b-col md="auto">
        <!-- Avatar -->
        <b-avatar
            :src="medicationImgUrl"
            size="4em"
            icon="pie-chart-fill"
            rounded="right"/>
        <b-avatar
            :src="medicationLblUrl"
            size="4em"
            icon="pie-chart-fill"
            rounded="right"/>
      </b-col>
      <b-col class="ml--2">
        <h4 class="mb-0">
          <a href="javascript:;">{{medicationName }}</a>
        </h4>
        <p class="text-sm text-muted mb-0"></p>
        <span v-if="isCurrentlyTaking" class="text-success">● </span>
        <span v-else class="text-danger">● </span>
        <small>Currently Taking</small>
      </b-col>
      <b-col md="auto">
        <b-row class="float-right">
          <b-col>
            <b-avatar
                :src="createdByImgURL"
                icon="pie-chart-fill"
                right
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="added_date">
            <i>added {{ added_date }}</i>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from "moment";

export default {
  name: "CallLog_PhotoCard",
  props: {
    med: { //
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    }
  },
  computed: {},
  methods:{
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    }
  },
  data() {
    return {
      isCurrentlyTaking: this.med ? this.med._isCurrentlyTaking : false,
      medicationName: this.med ? this.med.medicationName: '',
      medicationImgUrl: this.med && this.med.images && this.med.images.medicationImage ? this.med.images.medicationImage.imgURL: null,
      medicationLblUrl: this.med && this.med.images && this.med.images.medicationLabel ? this.med.images.medicationLabel.imgURL: null,
      createdByImgURL: this.med && this.med._created_by ? this.med._created_by.imgURL : null,
      createdByName: this.med && this.med._created_by ? this.med._created_by.name : null,
      added_date: this.med && this.med._created_at ? this.formatDate(this.med._created_at) :null
    };
  }
};
</script>

<style lang="scss" scoped>
.photo-card {
  width: 100%;
  //   height: 357px;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  border-radius: 8px !important;
  background: #ffffff;
  position: relative;
  font-family: "Nunito", sans-serif;
  .photo-bg {
    width: 100%;
    background: rgba(184, 136, 92, 0.1);
    background-color: #ddbc9e;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background-repeat: repeat-x;
  }
  .photo-sound-btn {
    position: absolute;
    left: 0%;
    top: 85%;
    text-align: left;
    background-color: rgba(10, 9, 9, 0.7);
    color: #272f75;
    font-weight: bold;
    cursor: pointer;
    height: 55px;
    width: 135px;
    font-size: 12px;
  }
}
</style>
